import type { SetupResultLink } from "@/types/SetupPlan";
import type { PackItemResult } from "../packResults";

/** Creator results → SetupPlan section resultLinks (persisted on the plan). */
export function resultsToLinks(items: PackItemResult[]): SetupResultLink[] {
  return items.map((item) => ({
    kind: item.kind,
    ...(item.key ? { key: item.key } : {}),
    ...(item.refId ? { refId: item.refId } : {}),
    title: item.label,
    url: item.link,
    ok: item.ok,
    ...(item.error ? { error: item.error } : {}),
  }));
}

/** emailKey → created templateId map from a BUILT EMAILS section's links. */
export function emailTemplateIdsFromLinks(
  links: SetupResultLink[] | undefined,
): Map<string, string> {
  const map = new Map<string, string>();
  for (const link of links ?? []) {
    if (link.kind === "email" && link.ok && link.key && link.refId) {
      map.set(link.key, link.refId);
    }
  }
  return map;
}

/** Item keys already created ok — skipped on an idempotent re-build. */
export function okKeysFromLinks(links: SetupResultLink[] | undefined): Set<string> {
  const set = new Set<string>();
  for (const link of links ?? []) {
    if (link.ok && link.key) set.add(link.key);
  }
  return set;
}

/** Merge a re-run's fresh results over the previous links (keyed items only once). */
export function mergeResultLinks(
  previous: SetupResultLink[] | undefined,
  fresh: SetupResultLink[],
): SetupResultLink[] {
  const kept = (previous ?? []).filter(
    (old) => old.ok && !fresh.some((f) => f.key && f.key === old.key),
  );
  return [...kept, ...fresh];
}
